import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-list-ordered",
  templateUrl: "./med-icon-list-ordered.component.html",
})
export class MedIconListOrderedComponent extends SvgMixinComponent {}
